'use client';

var EForceControDropdown;
(function (EForceControDropdown) {
    EForceControDropdown["JUST_SHOW_DROPDOWN_CONTENT"] = "JUST_SHOW_DROPDOWN_CONTENT";
    EForceControDropdown["JUST_SHOW_DROPDOWN_TREE_SELECT"] = "JUST_SHOW_DROPDOWN_TREE_SELECT";
    EForceControDropdown["CLOSE_ALL"] = "CLOSE_ALL";
})(EForceControDropdown || (EForceControDropdown = {}));

export { EForceControDropdown };
//# sourceMappingURL=types.js.map
